import Hierarchies_CriteriaPage from "@Criteria/Hierarchies/Pages/CriteriaPage.vue";
import Hierarchies_MeasurementsPage from "@Criteria/Hierarchies/Pages/MeasurementsPage.vue";
import Hierarchies_LegacyMeasurementsPage from "@Criteria/Hierarchies/Pages/LegacyMeasurementsPage.vue";

import Weights_WeightsPage from "@Criteria/Weights/Pages/WeightsPage.vue";

import WeightedScoresPage from "@Criteria/WeightedScores/Pages/WeightedScoresPage.vue";
import CreateWeightedScorePage from "@Criteria/WeightedScores/Pages/CreateWeightedScorePage.vue";
import EditWeightedScorePage from "@Criteria/WeightedScores/Pages/EditWeightedScorePage.vue";

export const routes = [
    {
        path: "/portfolio/criteria-hierarchy/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_CriteriaPage,
    },
    {
        path: "/decision/criteria-hierarchy/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_CriteriaPage,
    },

    {
        path: "/portfolio/measurement/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_MeasurementsPage,
    },
    {
        path: "/decision/measurement/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_MeasurementsPage,
    },

    {
        path: "/portfolio/criteria-scales/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_LegacyMeasurementsPage,
    },
    {
        path: "/decision/criteria-scales/:workspaceId/:projectId/:evalModelId",
        component: Hierarchies_LegacyMeasurementsPage,
    },

    {
        path: "/portfolio/criteria-surveys/:workspaceId/:projectId/:evalModelId",
        component: Weights_WeightsPage,
    },
    {
        path: "/decision/criteria-surveys/:workspaceId/:projectId/:evalModelId",
        component: Weights_WeightsPage,
    },

    {
        path: "/portfolio/weighted-scores/:workspaceId/:projectId/:evalModelId",
        component: WeightedScoresPage,
    },
    {
        path: "/decision/weighted-scores/:workspaceId/:projectId/:evalModelId",
        component: WeightedScoresPage,
    },



    {
        path: "/portfolio/create-weighted-score/:workspaceId/:projectId/:evalModelId?",
        component: CreateWeightedScorePage,
    },
    {
        path: "/decision/create-weighted-score/:workspaceId/:projectId/:evalModelId?",
        component: CreateWeightedScorePage,
    },

    {
        path: "/portfolio/edit-weighted-score/:workspaceId/:projectId/:evalModelId?",
        component: EditWeightedScorePage,
    },
    {
        path: "/decision/edit-weighted-score/:workspaceId/:projectId/:evalModelId?",
        component: EditWeightedScorePage,
    },
]
